import { Component } from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';

@Component({
  selector: 'rh-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  constructor(private afs: AngularFirestore) {

  }
}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/app.component.ts